import type { ContentPayload, DrummerProfile, Study, Technique } from "../types";
import { CONTENT_URL } from "../generated/content-url";

let contentPromise: Promise<ContentPayload> | undefined;

export function loadContent(): Promise<ContentPayload> {
  contentPromise ??= fetch(CONTENT_URL).then(async (response) => {
    if (!response.ok) throw new Error(`Ghostbeats content returned ${response.status}`);
    const contentType = response.headers.get("content-type") ?? "";
    if (!contentType.includes("application/json")) {
      throw new Error("A new Ghostbeats version was deployed. Reload to continue.");
    }
    try {
      return await response.json() as ContentPayload;
    } catch {
      throw new Error("Ghostbeats content was interrupted. Reload to try again.");
    }
  });
  return contentPromise;
}

export function profileMap(content: ContentPayload): Map<string, DrummerProfile> {
  return new Map(content.profiles.drummers.map((profile) => [profile.slug, profile]));
}

export function studyMap(content: ContentPayload): Map<string, Study> {
  return new Map(content.catalog.studies.map((study) => [study.slug, study]));
}

export function techniqueMap(content: ContentPayload): Map<string, Technique> {
  return new Map(content.catalog.techniques.map((technique) => [technique.slug, technique]));
}
